import { Component, ojs, app, state, v } from "modular-openscriptjs";
import { pageInfo, formatThousand, scrollToTop, getComponent, sendEvent, redirect } from "../../helpers";
import { dom } from "../../fotastart";
import { api, dc, uc } from "../../declarations";
import { routes } from "../../backendRoutes";
import InfiniteScroll from "../Blocks/InfiniteScroll";
import Spinner from "../Blocks/Spinner";
import { $e } from "../../ojs.events";

const h = app("h");

export default class SubscriptionsPage extends Component {
    loading = state(true);
    page = 1;
    lastPage = false;

    constructor() {
        super();
        this.loading.listener(this);
    }

   
    initPage() {
        this.page = 1;
        this.lastPage = false;
        this.loading.value = true;
    }

    render(...args) {
        pageInfo("My Subscriptions");
        scrollToTop();

        return h.div(
            {
                class: "min-vh-100 py-4 pb-5 mb-5 mx-auto w-100 py-md-5",
                style: "max-width: 900px;"
            },
            h.div(
                { class: "container px-3" },

                // Header
                h.div(
                    { class: "mb-4 d-flex align-items-center justify-content-between" },
                    h.div(
                        { class: "d-flex align-items-center gap-3" },
                        h.button(
                            {
                                class: "btn btn-white border shadow-sm circle p-2",
                                onclick: "history.back()",
                            },
                            h.i({ class: "bi bi-arrow-left fs-5 text-secondary" })
                        ),
                        h.h2({ class: "fw-bold mb-0 h4" }, "My Subscriptions")
                    )
                ),

                v(uc.subscription, (sub) => {
                    const hasActiveSub = sub.value && sub.value.id;

                    if (!hasActiveSub) {
                        return h.div(
                            {
                                class: "card border-0 rounded-4 p-4 text-white shadow-sm animated-cta-card mb-4",
                                style: "cursor: pointer;",
                                listeners: {
                                    click: () => sendEvent($e.subscription.needs.plans)
                                }
                            },
                            h.style(`
                                @keyframes gradientShift {
                                    0% { background-position: 0% 50%; }
                                    50% { background-position: 100% 50%; }
                                    100% { background-position: 0% 50%; }
                                }
                                .animated-cta-card {
                                    background: linear-gradient(-45deg, #5d5fef, #8247e9, #4f46e5, #6366f1);
                                    background-size: 300% 300%;
                                    animation: gradientShift 8s ease infinite;
                                    border: none !important;
                                    box-shadow: 0 8px 24px rgba(93, 95, 239, 0.25) !important;
                                }
                                .animated-cta-card:hover {
                                    transform: translateY(-2px) scale(1.005) !important;
                                    box-shadow: 0 12px 30px rgba(93, 95, 239, 0.4) !important;
                                    transition: all 0.3s ease;
                                }
                            `),
                            h.div(
                                { class: "d-flex align-items-center justify-content-between flex-wrap gap-3" },
                                h.div(
                                    { class: "d-flex align-items-center gap-3" },
                                    h.div(
                                        { class: "bg-dark bg-opacity-20 circle p-2 text-warning d-flex align-items-center justify-content-center", style: "width: 48px; height: 48px;" },
                                        h.i({ class: "bi bi-lightning-charge-fill fs-4" })
                                    ),
                                    h.div(
                                        h.h6({ class: "fw-bold text-white mb-1" }, "The Smarter Way to Order"),
                                        h.p({ class: "text-white text-opacity-90 small mb-0" }, "Subscribe to save over KES 2,300+ in delivery fee")
                                    )
                                ),
                                h.span({ class: "btn btn-light rounded-pill px-4 fw-bold text-primary", style: "color: #5d5fef!important;" }, "Subscribe →")
                            )
                        );
                    }

                    // Render active subscription details and usage info!
                    return h.div(
                        {
                            class: "card border-0 shadow-sm rounded-4 p-4 bg-white mb-4",
                            style: "border: 1px solid rgba(93, 95, 239, 0.08)!important;"
                        },
                        h.div(
                            { class: "d-flex flex-column gap-3 text-start" },
                            h.div(
                                { class: "d-flex justify-content-between align-items-center flex-wrap gap-2" },
                                h.div(
                                    { class: "d-flex gap-2 flex-column" },
                                    h.span(
                                        {
                                            class: `rounded fw-bold py-1 px-3 bg-success bg-opacity-10 text-success border border-success border-opacity-15`,
                                            style: "font-size: 0.72rem; width: fit-content;"
                                        },
                                        sub.value.trial_days > 0 ? "Active Trial" : "Active Subscription"
                                    ),
                                    h.h5({ class: "fw-bold mb-0 text-dark" }, sub.value.plan?.name || "Premium Plan")
                                ),
                                h.button(
                                    {
                                        class: "btn btn-outline-primary btn-sm rounded-pill px-3 fw-bold",
                                        listeners: {
                                            click: () => sendEvent($e.subscription.needs.plans)
                                        }
                                    },
                                    "Upgrade / Change Plan"
                                )
                            ),
                            h.hr({ class: "my-1 text-muted opacity-25" }),
                            h.div(
                                { class: "row g-3" },
                                h.call(() => {
                                    const subVal = sub.value;
                                    const progressCards = [];

                                    // Duration Progress
                                    const totalMs = new Date(subVal.expires_at) - new Date(subVal.started_at);
                                    const totalDays = Math.ceil(totalMs / (1000 * 60 * 60 * 24));
                                    const elapsedMs = new Date() - new Date(subVal.started_at);
                                    const usedDays = Math.max(0, Math.ceil(elapsedMs / (1000 * 60 * 60 * 24)));
                                    const displayUsedDays = Math.min(usedDays, totalDays);
                                    const durationPct = totalDays > 0 ? (displayUsedDays / totalDays) * 100 : 0;

                                    progressCards.push(
                                        h.div(
                                            { class: "col-md-6" },
                                            h.div(
                                                { class: "p-3 bg-light rounded-3 text-center h-100 d-flex flex-column justify-content-between" },
                                                h.small({ class: "text-muted d-block mb-1 text-uppercase fw-semibold" }, "Duration (Days Used)"),
                                                h.div({ class: "fw-bold text-dark font-monospace" }, `${displayUsedDays} / ${totalDays} Days`),
                                                h.div(
                                                    { class: "progress mt-2", style: "height: 6px;" },
                                                    h.div({
                                                        class: "progress-bar",
                                                        style: `background-color: #0dcaf0; width: ${durationPct}%;`
                                                    })
                                                )
                                            )
                                        )
                                    );

                                    // Feature Usages
                                    const featureConfig = {
                                        number_of_orders: { title: "Completed Orders", color: "#ffc107", suffix: "Orders" },
                                        ai_credits: { title: "AI Credits", color: "#973e87", suffix: "Credits" },
                                        virtual_distance: { title: "Distance (vKM)", color: "#5d5fef", suffix: "vKM" }
                                    };

                                    if (subVal.usages && Array.isArray(subVal.usages)) {
                                        subVal.usages.forEach((usage) => {
                                            const config = featureConfig[usage.feature_name];
                                            if (!config || Number(usage.limit) <= 0) return;

                                            const usedVal = Number(usage.used);
                                            const limitVal = Number(usage.limit);
                                            const pct = limitVal > 0 ? (usedVal / limitVal) * 100 : 0;

                                            progressCards.push(
                                                h.div(
                                                    { class: "col-md-6" },
                                                    h.div(
                                                        { class: "p-3 bg-light rounded-3 text-center h-100 d-flex flex-column justify-content-between" },
                                                        h.small({ class: "text-muted d-block mb-1 text-uppercase fw-semibold" }, config.title),
                                                        h.div({ class: "fw-bold text-dark font-monospace" }, `${usedVal} / ${limitVal} ${config.suffix}`),
                                                        h.div(
                                                            { class: "progress mt-2", style: "height: 6px;" },
                                                            h.div({
                                                                class: "progress-bar",
                                                                style: `background-color: ${config.color}; width: ${pct}%;`
                                                            })
                                                        )
                                                    )
                                                )
                                            );
                                        });
                                    }

                                    return progressCards;
                                })
                            ),
                            h.div(
                                { class: "d-flex justify-content-center mt-1" },
                                h.button(
                                    {
                                        class: "btn btn-link btn-sm text-secondary text-decoration-none fw-medium opacity-75",
                                        style: "font-size: 0.8rem;",
                                        listeners: {
                                            click: () => sendEvent($e.subscription.needs.cancel)
                                        }
                                    },
                                    "Cancel Subscription"
                                )
                            )
                        )
                    );
                }),

                v(this.loading, (l) => {
                    if (l.value) {
                        return h.div(
                            { class: "text-center py-5" },
                            h.div({ class: "spinner-border text-primary" })
                        );
                    }

                    return h.InfiniteScroll({
                        child: h.div({
                            class: "row g-4 w-100 m-0",
                            hook: "subscriptions-list",
                            uuid: "subscriptions-list-holder"
                        }),
                        callback: (entries, observer, marker) => {
                            if (entries[0]?.isIntersecting && !this.lastPage) {
                                this.fetchSubscriptions(marker);
                            }
                        },
                    });
                })
            ),
            ...args
        );
    }

    $_mounted(componentId) {
        let c = getComponent(componentId);

        if(!c) return;

        c.initPage();
        c.loading.value = false;
    }

    async fetchSubscriptions(marker) {
        if (this.lastPage) return;

        const holder = dom.get("[hook='subscriptions-list']");
        const spinner = h.Spinner({
            class: "p-3",
            parent: marker,
            resetParent: true,
        });

        let res = await api.get(
            routes.subscriptions,
            {
                page: this.page,
                interval: 10,
            },
            { silent: true }
        );

        if (!res) {
            spinner.remove();
            return;
        }

        const subscriptions = res.data.subscriptions.data;

        for (let sub of subscriptions) {
            let id = `sub-${sub.id}`;
            if (!dom.get(`[subscription-card-id="${id}"]`, holder)) {
                this.renderSubscriptionCard(sub, holder, id);
            }
        }

        spinner.remove();

        if (this.page >= res.data.subscriptions.last_page) {
            this.lastPage = true;
        } else {
            this.page++;
            h.button(
                h.i({
                    class: "bi bi-arrow-down-circle me-2 fs-5",
                    style: "line-height: 0;",
                }),
                "Load More",
                {
                    parent: marker,
                    class: "btn btn-outline-primary d-flex align-items-center justify-content-center mx-auto my-4 rounded-pill px-4 fw-semibold",
                    listeners: {
                        click: () => this.fetchSubscriptions(marker),
                    },
                }
            );
        }
    }

    renderSubscriptionCard(sub, parent, cardId) {
        const isCurrentlyActive = sub.status === "active" || sub.status === "trialing";
        const badgeColors = {
            active: "bg-success bg-opacity-10 text-success border-success border-opacity-10",
            trialing: "bg-info bg-opacity-10 text-info border-info border-opacity-10",
            expired: "bg-danger bg-opacity-10 text-danger border-danger border-opacity-10",
            cancelled: "bg-secondary bg-opacity-10 text-secondary border-secondary border-opacity-10",
            pending: "bg-warning bg-opacity-10 text-warning border-warning border-opacity-10"
        };

        const badgeClass = badgeColors[sub.status] || "bg-secondary text-white";

        const startDateStr = new Date(sub.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
        const endDateStr = sub.expires_at 
            ? new Date(sub.expires_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })
            : "N/A";

        h.div(
            {
                class: "col-12 p-0",
                "subscription-card-id": cardId,
                parent,
            },
            h.div(
                {
                    class: `card border-0 shadow-sm h-100 overflow-hidden ${isCurrentlyActive ? 'border-start border-4 border-success' : ''}`,
                    style: "border-radius: 16px; background: #ffffff; border: 1px solid rgba(0,0,0,0.03)!important;",
                },
                h.div(
                    { class: "card-body p-4 d-flex flex-column gap-3" },
                    h.div(
                        { class: "d-flex justify-content-between align-items-center flex-wrap gap-2" },
                        h.div(
                            h.h5({ class: "fw-bold mb-0 text-dark" }, sub.plan?.name || "Subscription"),
                            h.small({ class: "text-muted" }, `KES ${Number(sub.plan?.price || 0).toLocaleString()} / ${sub.plan?.interval_count} ${sub.plan?.interval}`)
                        ),
                        h.span(
                            { class: `badge rounded-pill fw-bold border py-1.5 px-3 text-uppercase ${badgeClass}`, style: "font-size: 0.75rem;" },
                            sub.status
                        )
                    ),
                    h.hr({ class: "my-1 text-muted opacity-25" }),
                    h.div(
                        { class: "row text-start text-secondary small py-1" },
                        h.div(
                            { class: "col-6" },
                            h.span({ class: "d-block text-muted text-uppercase font-monospace", style: "font-size: 0.65rem;" }, "Started On"),
                            h.strong({ class: "text-dark" }, startDateStr)
                        ),
                        h.div(
                            { class: "col-6" },
                            h.span({ class: "d-block text-muted text-uppercase font-monospace", style: "font-size: 0.65rem;" }, isCurrentlyActive ? "Renews/Expires On" : "Expired On"),
                            h.strong({ class: "text-dark" }, endDateStr)
                        )
                    )
                )
            )
        );
    }
}

ojs(SubscriptionsPage);
